// extracted by mini-css-extract-plugin
module.exports = {"title-position":"ParcelSelectFields_title-position__M0c2M","row-position":"ParcelSelectFields_row-position__Dkt9T"};